import { useState, useEffect, useRef } from "react";
import "../asset/css/Navbar.css";

/* ── data ─────────────────────────────────────── */
 

 

/* ── helpers ───────────────────────────────────── */
function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

function useCountUp(ref, target) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      let start = 0;
      const step = Math.ceil(target / 60);
      const tick = () => {
        start = Math.min(start + step, target);
        el.textContent = start.toLocaleString();
        if (start < target) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, { threshold: 0.5 });
    io.observe(el);
    return () => io.disconnect();
  }, [ref, target]);
}

 
 

/* ── main component ────────────────────────────── */
const Navbar = () => {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false); 
  const cursorRef     = useRef(null);
  const cursorRingRef = useRef(null);

  useReveal();

  /* navbar scroll */
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* custom cursor */
  useEffect(() => {
    const move = (e) => {
      if (cursorRef.current) {
        cursorRef.current.style.left = e.clientX + "px";
        cursorRef.current.style.top  = e.clientY + "px";
      }
      if (cursorRingRef.current) {
        cursorRingRef.current.style.left = e.clientX + "px";
        cursorRingRef.current.style.top  = e.clientY + "px";
      }
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  /* lock body when menu open */
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const navLinks = ["about", "genres", "how-it-works", "prizes", "judges", "timeline", "faq"];

  return (
    <>
 
      {/* ── NAVBAR ── */}
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="nav-logo">
          <span className="logo-icon">♪</span>
          <span className="logo-text">SoundBattle</span>
        </div>

        <ul className="nav-links">
          {navLinks.map((l) => (
            <li key={l}><a href={`#${l}`}>{l.replace(/-/g, " ")}</a></li>
          ))}
        </ul>

        <div className="nav-cta">
          <a href="#login"  className="btn-outline">Judge Login</a>
          <a href="#signup" className="btn-primary">Sign Up Free</a>
        </div>

        <button
          className="hamburger"
          aria-label="Menu"
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span /><span /><span />
        </button>
      </nav>

      {/* Mobile menu */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        {navLinks.map((l) => (
          <a key={l} href={`#${l}`} onClick={() => setMenuOpen(false)}>
            {l.replace(/-/g, " ")}
          </a>
        ))}
        <a href="#signup" className="mobile-cta" onClick={() => setMenuOpen(false)}>
          Sign Up Free
        </a>
      </div>

     
    </>
  );
};

export default Navbar;